import styled from 'styled-components'
import { OrderedList } from 'components/list'
import { Naked } from 'components/button'
import Paragraph from 'components/typography/paragraph'

export const Documents = styled(OrderedList)`
    overflow: hidden;

    border: 1px solid var(--huma-color-border-default);
    border-radius: 8px;
`

export const Button = styled(Naked)`
    width: 100%;
    height: auto;
    padding: 16px;

    text-align: start;

    &:not(:last-child) {
        border-bottom: 1px solid var(--huma-color-border-default);
    }

    &:where(:hover, :focus-visible) {
        background-color: var(--huma-color-surface-minimal);

        span {
            text-decoration: none !important;
        }
    }
`

export const Time = styled(Paragraph).attrs({
    as: 'time',
    className: 'caption small compact'
})`
    padding-inline-start: 40px;
`